import { render, staticRenderFns } from "./Attachment.vue?vue&type=template&id=1234fd33&scoped=true&"
import script from "./Attachment.vue?vue&type=script&lang=ts&"
export * from "./Attachment.vue?vue&type=script&lang=ts&"
import style0 from "./Attachment.vue?vue&type=style&index=0&id=1234fd33&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1234fd33",
  null
  
)

export default component.exports